// isDeliveryNotBlacklisted :: ({}) -> boolean
const isDeliveryNotBlacklisted = ({
  addressBlackListed,
  isBlackListed,
}: {
  addressBlackListed?: boolean
  isBlackListed?: boolean
}): boolean => {
  if (addressBlackListed || isBlackListed) {
    return false
  }

  return true
}

export default isDeliveryNotBlacklisted
